import { isInternalUrl } from '@bingads-webui/url-util';
import { AjaxStub, AjaxEventHandler, ErrorStub } from '@bingads-webui/instrumentation-stubs';
import { getInstrumentation as getInstrumentationInstance } from '@bingads-webui-campaign/instrumentation-setup';
import {
  OdataErrorMapper,
  CampaignApiErrorMapper,
  UrlErrorMapper,
  odataErrorCodes,
  campaignApiErrorCodes,
  invalidDomains,
} from '@bingads-webui-campaign/instrumentation';
import { pmaxLiteSchemas } from './pmax-lite-schemas';

export const SUB_SYSTEM_NAMES = {
  PMaxLiteSignup: 'pmax-lite-signup',
};

const errorMappers = {
  odataErrorMapper: new OdataErrorMapper(odataErrorCodes),
  campaignApiErrorMapper: new CampaignApiErrorMapper(campaignApiErrorCodes),
  urlErrorMapper: new UrlErrorMapper(invalidDomains),
};

function stub(instrumentation, serverContext) {
  const stubOptions = {
    pageTrackingId: serverContext && serverContext.PageTrackingId,
    lcid: serverContext && serverContext.CultureLcid,
  };

  const shouldAddHeaders = ajaxContext => isInternalUrl(ajaxContext.url);
  const eventHandler = new AjaxEventHandler({
    errorMappers,
    shouldAddHeaders,
  });

  const ajaxStub = new AjaxStub({
    stubOptions,
    eventHandler,
    instrumentation,
  });

  const errorStub = new ErrorStub({
    instrumentation,
  });

  ajaxStub.init();
  errorStub.init();
}

export const getInstrumentationService = ({ instrumentation, serverContext }) => {
  instrumentation.addScenario(pmaxLiteSchemas);
  const defaultScenario = instrumentation.defaultScenario.create();
  const logger = defaultScenario.logger.create();

  stub(instrumentation, serverContext);

  return {
    instrumentation,
    logger,
  };
};

export const getInstrumentation = ({
  serverContext,
  devConfig,
  subSystemName = SUB_SYSTEM_NAMES.PMaxLiteSignup,
}) => {
  const {
    CurrentCustomer,
    CurrentAccount,
    CurrentUser,
  } = serverContext;

  const userContext = {
    CurrentCustomer: CurrentCustomer || {},
    CurrentAccount: CurrentAccount || {},
    CurrentUser: CurrentUser || {},
  };

  return getInstrumentationInstance({
    pageTrackingId: serverContext.PageTrackingId,
    errorMappers,
    isInDevelopmentMode: devConfig.isInDevelopmentMode,
    userContext,
    applicationName: {
      systemName: 'campaign',
      subSystemName,
    },
    serverContext: {
      // Ui Next is using dynamic permissions config
      // We don't have that in sign up bundle context. Enable it for all users to expose errors.
      DynamicPermissions: {
        EnableLoggingForUnhandledPromiseRejections: true,
      },
      ...serverContext,
      ...userContext,
    },
    objectsToStub: [],
  });
};
